import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { format } from 'date-fns';
import { DashboardKpiService, SalesSummaryEntity, SalesSummaryGroup } from 'gung-dashboard';
import { Observable, forkJoin, first, map } from 'rxjs';

export class SalesFieldSummaryGroup {
  [s: string]: {
    totalValueCurrency: number;
    totalValue: number;
    totalQuantity: number;
    totalRecords: number;
    ids: any[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class CultDashboardKpiService extends DashboardKpiService{

  constructor(protected http: HttpClient) {
    super(http);
  }

  public getSalesByFields(fromDate: Date, toDate: Date): Observable<SalesFieldSummaryGroup> {
    const url = `${this.baseUrl}/sales-by-fields`;
    const params: { [key: string]: string } = {
      fields: 'ProductCategoryCode',
      entries: '1000',
      entryAccumulator: 'TotalQuantity',
      minDate: format(fromDate, 'yyyy-MM-dd'),
      maxDate: format(toDate, 'yyyy-MM-dd')
    };
    
    return this.http.get<SalesFieldSummaryGroup>(url, { params });
    
  }

  public getSalesSummary(
    entity: SalesSummaryEntity,
    fromDate: Date,
    toDate: Date = null,
    preConditions: any = null
  ): Observable<SalesSummaryGroup[]> {
    // In case there is a final date defined
    // then retrieve the data for both dates as starting dates
    // then subtract the values for after the toDate
    if (!!toDate) {
      return forkJoin({
        olderSalesSummaryGroups: this.getSalesSummary(entity, fromDate, null, preConditions).pipe(first()),
        recentSalesSummaryGroups: this.getSalesSummary(entity, toDate, null, preConditions).pipe(first())
      }).pipe(
        first(),
        map(({ olderSalesSummaryGroups, recentSalesSummaryGroups }) => {
          // go through all olderSalesSummaryGroup and subsctrat the quantities from recentSalesSummaryGroups
          // In Case the totalQty are equal in both older and recent
          // that means that the invoice were made on-or-after the toDate (only in the period of the recent one)
          // those should not be added to the return array
          const toReturn: SalesSummaryGroup[] = [];
          const olderSalesSummaryGroupsCopy: SalesSummaryGroup[] = JSON.parse(JSON.stringify(olderSalesSummaryGroups));

          for (const olderSalesSummaryGroup of olderSalesSummaryGroupsCopy) {
            const recentSalesSummaryGroup = recentSalesSummaryGroups.find(
              summary => summary.id === olderSalesSummaryGroup.id
            );

            // in case product bought on-or-after toDate check
            //      THEN if the totalQty is different and add if diff
            // otherwise in not found in recent it means it was bought only in period fromDate until toDate
            if (!!recentSalesSummaryGroup) {
              if (recentSalesSummaryGroup.totalQuantity !== olderSalesSummaryGroup.totalQuantity) {
                olderSalesSummaryGroup.totalAmount -= recentSalesSummaryGroup.totalAmount;
                olderSalesSummaryGroup.totalQuantity -= recentSalesSummaryGroup.totalQuantity;
                toReturn.push(olderSalesSummaryGroup);
              }
            } else {
              toReturn.push(olderSalesSummaryGroup);
            }
          }
          return toReturn;
        })
      );
    }

    var url = `${this.baseUrl}/sales-summary`;
    if (preConditions) {
      
      if(preConditions?.salesPersonId != null){
        // returns invoices connected to salesperson instead
        url = `${this.baseUrl}-salesperson/summary`;
      }
      return this.http.post<SalesSummaryGroup[]>(url, preConditions, {
        params: {
          fromDate: format(fromDate, 'yyyy-MM-dd'),
          entity: SalesSummaryEntity[entity]
        }
      });
    } else {
      return this.http.get<SalesSummaryGroup[]>(url, {
        params: {
          fromDate: format(fromDate, 'yyyy-MM-dd'),
          entity: SalesSummaryEntity[entity]
        }
      });
    }
  }

  /* public getSalesByFields(
    fromDate: Date,
    toDate: Date = null,
    preConditions: any = null
  ): Observable<SalesFieldSummaryGroup> {
    if (!!toDate) {
      return forkJoin({
        salesThisYear: this.getSalesByFields(fromDate, null, preConditions).pipe(first()),
        salesLastYear: this.getSalesByFields(toDate, null, preConditions).pipe(first())
      }).pipe(
        first(),
        map(({ salesThisYear, salesLastYear }) => {
          const toReturn: SalesFieldSummaryGroup = {};
          const salesThisYearCopy: SalesFieldSummaryGroup = JSON.parse(
            JSON.stringify(salesThisYear)
          );

          for (const key of Object.keys(salesThisYearCopy)) {
            const olderSalesSummaryGroup = salesThisYearCopy[key];
            const recentSalesSummaryGroup = salesLastYear[key];
            if (!!recentSalesSummaryGroup) {
              if (recentSalesSummaryGroup.totalQuantity !== olderSalesSummaryGroup.totalQuantity) {
                olderSalesSummaryGroup.totalValue -= recentSalesSummaryGroup.totalValue;
                olderSalesSummaryGroup.totalRecords -= recentSalesSummaryGroup.totalRecords;
                olderSalesSummaryGroup.totalQuantity -= recentSalesSummaryGroup.totalQuantity;
                olderSalesSummaryGroup.totalValueCurrency -= recentSalesSummaryGroup.totalValueCurrency;
                olderSalesSummaryGroup.ids = olderSalesSummaryGroup.ids.filter(id =>
                  recentSalesSummaryGroup.ids.includes(id)
                );
                toReturn[key] = olderSalesSummaryGroup;
              }
            } else {
              toReturn[key] = olderSalesSummaryGroup;
            }
          }

          return toReturn;
        })
      );
    }

    const url = `${this.baseUrl}/sales-by-fields`;
    const params = {
      fields: 'ProductCategoryCode',
      entries: '1000',
      entryAccumulator: 'TotalQuantity',
      minDate: format(fromDate, 'yyyy-MM-dd')
    };
    if (preConditions) {
      return this.http.post<SalesFieldSummaryGroup>(url, preConditions, { params });
    } else {
      return this.http.get<SalesFieldSummaryGroup>(url, { params });
    }
  } */
}
